import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function getDailyTasks(params = {}, token) {
  const res = await axios.get(`${API}/daily-tasks`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createDailyTask(payload, token) {
  const res = await axios.post(`${API}/daily-tasks`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateDailyTask(taskId, payload, token) {
  const res = await axios.put(`${API}/daily-tasks/${taskId}`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function deleteDailyTask(taskId, token) {
  const res = await axios.delete(`${API}/daily-tasks/${taskId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function completeDailyTask(taskId, payload = {}, token) {
  const res = await axios.post(`${API}/daily-tasks/${taskId}/complete`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function uncompleteDailyTask(taskId, params = {}, token) {
  const res = await axios.delete(`${API}/daily-tasks/${taskId}/complete`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}
